import { createContext } from 'react'
import type { LoginOutcome, TenantCandidate, TotpOutcome, CurrentUser } from './authApi'
import type { Permission } from './permissions'

export interface AuthContextValue {
  /** `null` — kirilmagan yoki `me` hali yuklanmagan */
  user: CurrentUser | null
  isAuthenticated: boolean
  /** Token bor, lekin `me` hali kelmagan */
  isLoading: boolean
  /** `me` so'rovi xato bergan — token bor, lekin kim ekani noma'lum */
  error: unknown
  /**
   * Login va parol bilan kirishga urinadi.
   *
   * ⚠️ Kirish shu yerda HECH QACHON tugamaydi — TOTP endi tenantdan mustaqil
   * va MAJBURIY. Natija doim ikkitadan biri: TOTP birinchi sozlash yoki
   * TOTP kod so'rash. Chaqiruvchi (`LoginPage`) shu bo'yicha `/login/totp`
   * ga yo'naltiradi.
   */
  signIn: (username: string, password: string) => Promise<LoginOutcome>
  /** `CHOOSE_TENANT` ekranida karta bosilganda — bu ENDI YAKUNIY qadam */
  completeTenantChoice: (choiceToken: string, tenantId: string) => Promise<void>
  /**
   * Birinchi TOTP sozlashda — QR/sirni tasdiqlovchi kod.
   *
   * ⚠️ NATIJA BIR QIYMAT EMAS: kod to'g'ri bo'lsa ham kirish shu yerda
   * tugashi (`kind: 'authenticated'`) yoki tashkilot tanlashga o'tishi
   * (`kind: 'chooseTenant'`) yoki hisobning faol a'zoligi yo'qligi
   * (`kind: 'noMembership'`) mumkin. Chaqiruvchi (`TotpPage`) shu bo'yicha
   * yo'naltiradi.
   */
  completeTotpSetup: (setupToken: string, code: string) => Promise<TotpOutcome>
  /** Har safargi kirishda — TOTP kod tekshiruvi. Natija yuqoridagi bilan bir xil. */
  completeTotpVerify: (totpToken: string, code: string) => Promise<TotpOutcome>
  /**
   * Sessiya DAVOMIDA boshqa tashkilotga o'tish.
   *
   * ⚠️ Bu `completeTenantChoice` EMAS: u kirish oqimining oxirgi qadami
   * va `choiceToken` talab qiladi. Bu esa allaqachon ochilgan sessiya
   * ichida ishlaydi.
   *
   * ⚠️ Chaqiruv MUVAFFAQIYATLI bo'lsa BUTUN so'rov keshi tozalanadi —
   * sabab `AuthProvider` dagi amalga oshirishda.
   */
  switchTenant: (tenantId: string) => Promise<void>
  signOut: () => Promise<void>
  /**
   * Huquq tekshiruvi. ⚠️ Bu QULAYLIK, xavfsizlik EMAS (04-ROLES.md §8):
   * backend baribir har so'rovda tekshiradi. Bu yerda yashirish faqat
   * ko'rinmaydigan sahifaga havola chizmaslik uchun.
   */
  can: (permission: Permission) => boolean
}

export type { TenantCandidate }

// Providersiz ishlatish — dastur tuzilishidagi xato, shuning uchun
// standart qiymat emas `null` va hook'da aniq xato.
export const AuthContext = createContext<AuthContextValue | null>(null)
